import { env } from '../config';

const BADGES = {
	[env.prod]: { label: 'PROD', color: 'error' },
	[env.uat]: { label: 'UAT', color: 'warning' },
	[env.staging]: { label: 'STAGING', color: 'warning' },
	[env.dev]: { label: 'DEV', color: 'default' },
};

/** Header chip for the environment this UI is talking to; a dev build always shows DEV. */
export const envBadge = (currentEnv, isDev = false) => {
	if (isDev) return BADGES[env.dev];
	return BADGES[currentEnv] ?? { label: String(currentEnv ?? '').toUpperCase() || 'UNKNOWN', color: 'default' };
};
